// Performance Optimization Script for Shopify Theme
(function() {
  'use strict';

  // 1. Lazy Loading for Images
  const lazyImageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        
        // Handle regular images
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        
        // Handle responsive images with srcset
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
          img.removeAttribute('data-srcset');
        }
        
        // Handle background images
        if (img.dataset.bgSrc) {
          img.style.backgroundImage = `url(${img.dataset.bgSrc})`;
          img.removeAttribute('data-bg-src');
        }
        
        img.classList.add('lazy-loaded');
        observer.unobserve(img);
      }
    });
  }, {
    rootMargin: '50px 0px',
    threshold: 0.01
  });

  // Initialize lazy loading
  function initLazyLoading() {
    const lazyImages = document.querySelectorAll('img[data-src], img[data-srcset], [data-bg-src]');
    lazyImages.forEach(img => lazyImageObserver.observe(img));
  }

  // 2. Defer Non-Critical CSS
  function loadDeferredStyles() {
    const deferredStyles = document.querySelectorAll('link[data-deferred-style]');
    deferredStyles.forEach(link => {
      link.setAttribute('rel', 'stylesheet');
      link.removeAttribute('data-deferred-style');
    });
  }

  // 3. Optimize Third-Party Scripts
  function loadThirdPartyScripts() {
    // Load analytics and tracking scripts after main content
    setTimeout(() => {
      // Google Analytics
      if (window.ga_tracking_id) {
        const gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${window.ga_tracking_id}`;
        document.head.appendChild(gaScript);
      }
      
      // Facebook Pixel
      if (window.fb_pixel_id) {
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', window.fb_pixel_id);
        fbq('track', 'PageView');
      }
    }, 3000);
  }

  // 4. Preload Critical Resources
  function preloadCriticalResources() {
    // Preload next page links on hover
    let preloadTimer;
    document.addEventListener('mouseover', (e) => {
      const link = e.target.closest('a');
      if (link && link.href && !link.dataset.preloaded) {
        clearTimeout(preloadTimer);
        preloadTimer = setTimeout(() => {
          const preloadLink = document.createElement('link');
          preloadLink.rel = 'prefetch';
          preloadLink.href = link.href;
          document.head.appendChild(preloadLink);
          link.dataset.preloaded = 'true';
        }, 100);
      }
    });
  }

  // 5. Optimize Shopify Specific Elements
  function optimizeShopifyElements() {
    // Defer product recommendations
    const recommendations = document.querySelectorAll('[data-product-recommendations]');
    if (recommendations.length > 0) {
      const recObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const elem = entry.target;
            if (elem.dataset.url && !elem.dataset.loaded) {
              fetch(elem.dataset.url)
                .then(response => response.text())
                .then(html => {
                  elem.innerHTML = html;
                  elem.dataset.loaded = 'true';
                })
                .catch(err => console.error('Failed to load recommendations:', err));
              recObserver.unobserve(elem);
            }
          }
        });
      }, { rootMargin: '100px' });
      
      recommendations.forEach(elem => recObserver.observe(elem));
    }

    // Optimize cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && !cartDrawer.dataset.optimized) {
      cartDrawer.dataset.optimized = 'true';
      // Load cart drawer content only when needed
      document.addEventListener('cart:open', () => {
        if (!cartDrawer.dataset.loaded) {
          // Load cart drawer content
          cartDrawer.dataset.loaded = 'true';
        }
      }, { once: true });
    }
  }

  // 6. Resource Cleanup
  function cleanupResources() {
    // Remove unused CSS classes periodically
    const unusedClasses = ['.no-js', '.shopify-design-mode'];
    unusedClasses.forEach(className => {
      const elements = document.querySelectorAll(className);
      elements.forEach(el => {
        if (!document.body.classList.contains('shopify-design-mode')) {
          el.classList.remove(className.replace('.', ''));
        }
      });
    });
  }

  // 7. Performance Monitoring
  function monitorPerformance() {
    if ('PerformanceObserver' in window) {
      // Monitor Largest Contentful Paint
      try {
        const lcpObserver = new PerformanceObserver((entryList) => {
          const entries = entryList.getEntries();
          const lastEntry = entries[entries.length - 1];
          console.log('LCP:', lastEntry.renderTime || lastEntry.loadTime);
        });
        lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
      } catch (e) {
        // LCP not supported
      }

      // Monitor Cumulative Layout Shift
      try {
        const clsObserver = new PerformanceObserver((entryList) => {
          let cls = 0;
          for (const entry of entryList.getEntries()) {
            if (!entry.hadRecentInput) {
              cls += entry.value;
            }
          }
          console.log('CLS:', cls);
        });
        clsObserver.observe({ entryTypes: ['layout-shift'] });
      } catch (e) {
        // CLS not supported
      }
    }
  }

  // 8. Initialize all optimizations
  function init() {
    // Wait for DOM to be interactive
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Start optimizations
    initLazyLoading();
    preloadCriticalResources();
    optimizeShopifyElements();
    
    // Defer non-critical operations
    requestIdleCallback(() => {
      loadDeferredStyles();
      cleanupResources();
      monitorPerformance();
    });

    // Load third-party scripts after main content
    window.addEventListener('load', () => {
      loadThirdPartyScripts();
    });

    // Re-initialize on Shopify navigation
    document.addEventListener('shopify:section:load', () => {
      initLazyLoading();
      optimizeShopifyElements();
    });
  }

  // Start initialization
  init();

})();